import React, { useState, useEffect } from 'react';
import { Alert, Container, Form, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import DynamicList from '../../../../../components/dynamic_list/DynamicList';
import { Loader } from '../../../../../components/loader/Loader';
import { getSurveyTemplateQuestionsOptions, deleteSurveyQuestionOption } from '../../../../../redux/survey/surver_template/questions/actions';
import CustomTabs from '../../../../../components/tabs/CustomTabs';
import { tabsOptionsAnswers } from './tabsOptionsAnwers';

const QuestionOption = ({ sortableState, setSortableState, type, formValues }) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const { surveyTemplate } = useSelector(state => state.surveyTemplate);

  const dispatch = useDispatch();

  const addItem = () => {
    setSortableState([...sortableState, { id: null, description: '' }]);
    setEditingIndex(sortableState.length);
    setEditingValue('');
  };

  const editItem = (index, value) => {
    setEditingIndex(index);
    setEditingValue(value.description);
  };

  const deleteItem = (index) => {
    if (sortableState[index].id) {
      dispatch(deleteSurveyQuestionOption(sortableState[index].id));
    }
    setSortableState(sortableState.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      let newSortableState = [...sortableState];
      if (editingIndex !== null) {
        newSortableState[editingIndex].description = editingValue;
        setSortableState(newSortableState);
      } else {
        newSortableState = [...sortableState, {id: null, description: editingValue}];
        setSortableState(newSortableState);
      }
      if (editingIndex < sortableState.length && editingValue.trim() !== '') {
        setEditingIndex(editingIndex + 1);
        setEditingValue(sortableState[editingIndex + 1]?.description || '');
      }
      if (editingIndex === sortableState.length -1 && editingValue.trim() !== '') {
        addItem(newSortableState);
      }
    }
  };

  const handleBlur = () => {
    if (editingIndex !== null) {
      if (editingValue.trim() === '') {
        deleteItem(editingIndex);
      } else {
        const newSortableState = sortableState.map((item, index) =>
          index === editingIndex ? { ...item, description: editingValue } : item
        );
        setSortableState(newSortableState);
      }
      setEditingIndex(null);
      setEditingValue('');
    }
  };

  return (
    <DynamicList
      sortableState={sortableState}
      editingIndex={editingIndex}
      editingValue={editingValue}
      onAddItemList={addItem}
      onBlur={handleBlur}
      onDeleteItemList={deleteItem}
      onEditItemList={editItem}
      onKeyPress={handleKeyPress}
      setEditingValue={setEditingValue}
      setSortableState={setSortableState}
      formValues={formValues}
      showSetScoreButton={surveyTemplate.survey_type === "Evaluación"}
      type={type}
    />
  );
};

const Answers = ({questionType, sortableStateRow, setSortableStateRow, sortableStateColumn, setSortableStateColumn, question, formValues}) => {
  return (
    <>
      <h5 className="my-3">{questionType === 'Matriz' ? 'Filas' : 'Opciones'}</h5>
      <QuestionOption sortableState={sortableStateRow} setSortableState={setSortableStateRow} type="rows" question={question} formValues={formValues} />
      {questionType === 'Matriz' && (
        <>
          {sortableStateColumn.length === 0 && <Alert variant="info" className="my-3">No hay opciones, comienza agregando algunas</Alert>}
          <h5 className="my-3">Columnas</h5>
          <QuestionOption sortableState={sortableStateColumn} setSortableState={setSortableStateColumn} type="columns" />
        </>
      )}
    </>
  );
}

const Combinations = ({columns, rows, getCombinations, serverCombinations}) => {
  const [combinations, setCombinations] = useState([]);
  useEffect(() => {
    if (serverCombinations) {
      setCombinations(serverCombinations);
    }
  }, [serverCombinations])
  
  
  const [values, setValues] = useState({ column: '', row: '' });
  const [touched, setTouched] = useState({ column: false, row: false });
  const [errors, setErrors] = useState({ column: '', row: '' });
  const [error, setError] = useState('');

  const onSubmit = () => {
    let errs = {};
    if (!values.column) {
      errs.column = 'Campo requerido';
    }
    if (!values.row) {
      errs.row = 'Campo requerido';
    }

    if (combinations.find(combination => combination.column === values.column && combination.row === values.row)) {
      setError('La combinación ya existe');
      return;
    }
    setErrors(errs);
    setError('');
    if (values.column && values.row) {
      const comb = [...combinations, { column: values.column, row: values.row }]
      setCombinations(comb);
      getCombinations(comb);
      setValues({ column: '', row: '' });
    }

  }
 
  return (
    <>
      {error && <Alert variant="danger" className="my-3">{error}</Alert>}
      <div className="d-flex mt-3 align-items-end">
        <Form.Group className='mr-3 mb-0'>
          <Form.Label>Columna</Form.Label>
          <Form.Control
            as="select"
            name="column"
            size="sm"
            onChange={(e) => setValues({ ...values, column: e.target.value })}
            onBlur={() => setTouched({ ...touched, column: true })}
            value={values.column}
            isInvalid={touched.column && errors.column}>
            <option value="">Selecciona una columna</option>
            {
              columns.map((column, index) => (
                <option key={index} value={column.description}>{column.description}</option>
              ))
            }
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            {errors.column}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mr-3 mb-0'>
          <Form.Label>Fila</Form.Label>
          <Form.Control
            size="sm"
            as="select"
            name="row"
            onChange={(e) => setValues({ ...values, row: e.target.value })}
            onBlur={() => setTouched({ ...touched, row: true })}
            value={values.row}
            isInvalid={touched.row && errors.row}>
            <option value="">Selecciona una fila</option>
            {
              rows.map((row, index) => (
                <option key={index} value={row.description}>{row.description}</option>
              ))
            }
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            {errors.row}
          </Form.Control.Feedback>
        </Form.Group>
        <div>
          <button type="button" className={`btn btn-primary btn-sm ${ errors.column || errors.row ? 'mb-4' : '' }`} onClick={() => onSubmit()}>Agregar combinación</button>
        </div>
      </div>
      <div className="mt-3">
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Columna</th>
              <th>Fila</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {combinations.map((combination, index) => (
              <tr key={index}>
                <td>{combination.column}</td>
                <td>{combination.row}</td>
                <td>
                  <button type="button" className="btn btn-danger btn-sm" onClick={() => {
                    const newCombinations = combinations.filter((_, i) => i !== index);
                    setCombinations(newCombinations);
                    getCombinations(newCombinations);
                  }}>Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

const QuestionAnswers = ({ question, questionType, setSortableState, formValues }) => {
  const [sortableStateRow, setSortableStateRow] = useState([]);
  const [sortableStateColumn, setSortableStateColumn] = useState([]);
  const [combinations, setCombinations] = useState([]);
  const { surveyTemplateQuestionOptions, isLoadingQuestionOptions, errorQuestionOptions } = useSelector(
    (state) => state.surveyTemplateQuestions
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (question) {
      dispatch(getSurveyTemplateQuestionsOptions({ question_id: question.id }));
    }
  }, [dispatch, question]);

  useEffect(() => {
    debugger
    if (questionType === 'Matriz') {
      setSortableStateColumn(getOptionsByType('Columna'));
    }
    setSortableStateRow(getOptionsByType('Fila'));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionType, surveyTemplateQuestionOptions]);

  const getOptionsByType = (type) => {
    //TODO: Refactor this the new structure is going to be { combinations: [], options: [] }
    return surveyTemplateQuestionOptions?.options?.filter((option) => (type === 'Columna' ? option.type === 'Columna' : option.type !== 'Columna'));
  };
  const getColumnOptions = React.useCallback(() => {
    return sortableStateColumn.map((option, index) => ({ id: option.id, description: option.description, type: 'Columna', secuence: index + 1, question: question ? question.id : null, score: option.score }));
  }, [sortableStateColumn, question]);

  const getRowOptions = React.useCallback(() => {
    return sortableStateRow.map((option, index) => ({ id: option.id, description: option.description, type: questionType !== 'Matriz' ? null: 'Fila', secuence: index + 1, question: question ? question.id : null, score: option.score }));
  }, [sortableStateRow, questionType, question]);
  useEffect(() => {
    setSortableState({combinations, options: [...getColumnOptions(), ...getRowOptions()]});
  }
  , [getColumnOptions, getRowOptions, setSortableState, combinations]);

  const _tabsOptionsAnswers = tabsOptionsAnswers(<Answers questionType={questionType} sortableStateRow={sortableStateRow} setSortableStateRow={setSortableStateRow} sortableStateColumn={sortableStateColumn} setSortableStateColumn={setSortableStateColumn} question={question} formValues={formValues} />, <Combinations columns={sortableStateColumn} rows={sortableStateRow} getCombinations={setCombinations} serverCombinations={surveyTemplateQuestionOptions.combinations} />, questionType);

  return (
    <Container>
      {isLoadingQuestionOptions ? (
        <Loader />
      ) : (
        <div className="mt-3">
          {errorQuestionOptions && <Alert variant="danger my-3">{errorQuestionOptions}</Alert>}
          {sortableStateRow.length === 0 && <Alert variant="info" className="my-3">No hay opciones, comienza agregando algunas</Alert>}
          <CustomTabs 
              variant="pills"
              defaultActiveKey="answers"
              id="tabsOptionsAnswers"
              tabs={_tabsOptionsAnswers} />
        </div>
      )}
    </Container>
  );
};

export default QuestionAnswers;
